import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {articleRevenue_template} from "../components/templates/articleRevenue_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class articleRevenue extends vnModule_knockoutJS{

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdl: XMLHttpRequestHandler;
    protected articleRevenue_template: articleRevenue_template;

    static premiumFilter : Array<{id : string, name : string}> = [
        { "id": "all",  "name": "All"},
        { "id": "premium",  "name": "Premium"},
        { "id": "regular",  "name": "Regular"},
    ];

    static reportLimit : Array<{id : string, name : string}> = [
        //{ "id": null,  "name": "All"},
        { "id": "50",  "name": "50"},
        { "id": "100",  "name": "100"},
        { "id": "250",  "name": "250"},
        { "id": "500",  "name": "500"},
        { "id": "1000",  "name": "1000"},
        //{ "id": "2000",  "name": "2000"},
        //{ "id": "5000",  "name": "5000"},
    ];

    static contentTypesGroup : Array<{id : string, name : string}> = [
        { "id": "all", "name": "all"},
        { "id": "shortForm", "name": "Short"},
        { "id": "longForm", "name": "Long"}
    ];

    protected getModuleName(){
        return "articleRevenue";
    }

    buildContent() : Array<Element>{

        this.articleRevenue_template = new articleRevenue_template( "articleRevenue", this.viewModel, this );
        this.template = this.articleRevenue_template;

        return [this.articleRevenue_template.build()];
    }

    public fillPage() : void{
        this.articleRevenue_template.buildDatePickerCalendar();

        this.getSearchPresetsListData();
    }

    public getListFormData(): void{
        let readyStateFunction;
        let usrReq_url: string = '';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );

        switch (this.articleRevenue_template.getTemplateViewModel().viewModeSelected()) {
            case 'topPerformingArticles':
                usrReq_url = '/api/topPerformingArticle/references';
                readyStateFunction = this.onTopPerformingArticleFilterRequestReturn;
            break;
            default:
                usrReq_url = '/api/articleRevenue/references';
                readyStateFunction = this.onFilterRequestReturn;
            break;
        }

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = readyStateFunction;
        this.XHRHdl.execute();

    }

    public getListData(): void{
        let subViewModel;
        let dataRequestReturn;
        let baseApiUrl: string = '';
        let identifier: string = '';

        this.loadingIn(this.articleRevenue_template.builtTemplate.children.namedItem("content-wrapper"));

        switch(this.articleRevenue_template.getTemplateViewModel().viewModeSelected()) {
            case 'topPerformingArticles':
                subViewModel = this.articleRevenue_template.getViewModelForTopPerformingArticlesRequest();
                baseApiUrl = '/api/topPerformingArticle/get';
                identifier = 'getTopPerformingArticlesListData';
                dataRequestReturn = this.onTopPerformingArticlesDataRequestReturn;
            break;
            default:
                subViewModel = this.articleRevenue_template.getViewModelForRequest();
                baseApiUrl = '/api/articleRevenue/get';
                identifier = 'getListData';
                dataRequestReturn = this.onDataRequestReturn;
            break;
        }

        this.sendFilterCall(baseApiUrl, subViewModel, dataRequestReturn, XMLHttpRequestHandler_requestType.GET, identifier);
    }

    protected getMultipleAutoCompleteSuggestions(id, keyword): void{

        if( this.XHRHdl ){

            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {
            filters      : {
                keyword : keyword,
            }
        };

        let usrReq_url;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        switch (id){
            case 'primaryCategoriesFilter':
            case 'topPerformingArticlePrimaryCategoriesFilter':
                usrReq_url = '/api/emakiCategorySuggestions/';
                break;
            case 'primaryTagsFilter':
            case 'topPerformingArticlePrimaryTagsFilter':
            case 'tagsFilter':
                usrReq_url = '/api/emakiBasicTagSuggestions/';
                break;
            case 'tagTypesFilter':
                usrReq_url = '/api/emakiBasicTagTypeSuggestions/';
                break;
            case 'srEditorsFilter':
            case 'jrEditorsFilter':
            case 'authorsFilter':
            case 'ideatorsFilter':
                usrReq_url = '/api/emakiUsers/get/';
                break;
        }

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        switch (id){
            case 'primaryCategoriesFilter':
                this.XHRHdl.onReadyStateFunction = this.onGetMultipleAutoCompleteCategoriesSuggestionsReturn;
                break;
            case 'primaryTagsFilter':
                this.XHRHdl.onReadyStateFunction = this.onGetMultipleAutoCompletePrimaryTagsSuggestionsReturn;
                break;
            case 'topPerformingArticlePrimaryCategoriesFilter':
                this.XHRHdl.onReadyStateFunction = this.onGetMultipleAutoCompleteTopPerformingCategoriesSuggestionsReturn;
                break;
            case 'topPerformingArticlePrimaryTagsFilter':
                this.XHRHdl.onReadyStateFunction = this.onGetMultipleAutoCompleteTopPerformingTagsSuggestionsReturn;
                break;
            case 'tagsFilter':
                this.XHRHdl.onReadyStateFunction = this.onGetMultipleAutoCompleteTagsSuggestionsReturn;
                break;
            case 'tagTypesFilter':
                this.XHRHdl.onReadyStateFunction = this.onGetMultipleAutoCompleteTagTypesSuggestionsReturn;
                break;
            case 'srEditorsFilter':
                this.XHRHdl.onReadyStateFunction = this.onGetMultipleAutoCompleteSrEditorsSuggestionsReturn;
                break;
            case 'jrEditorsFilter':
                this.XHRHdl.onReadyStateFunction = this.onGetMultipleAutoCompleteJrEditorsSuggestionsReturn;
                break;
            case 'authorsFilter':
                this.XHRHdl.onReadyStateFunction = this.onGetMultipleAutoCompleteAuthorSuggestionsReturn;
                break;
            case 'ideatorsFilter':
                this.XHRHdl.onReadyStateFunction = this.onGetMultipleAutoCompleteIdeatorSuggestionsReturn;
                break;
        }

        this.XHRHdl.execute();
    }

    protected onGetMultipleAutoCompleteSrEditorsSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.articleRevenue_template.validationsList.clearMessages();
                if (responseParsed.data) {

                    obj.articleRevenue_template.setSrEditorsFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.articleRevenue_template.deactivateLoading();
            });
        }
    }

    protected onGetMultipleAutoCompleteJrEditorsSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.articleRevenue_template.validationsList.clearMessages();
                if (responseParsed.data) {

                    obj.articleRevenue_template.setJrEditorsFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.articleRevenue_template.deactivateLoading();
            });
        }
    }

    protected onGetMultipleAutoCompleteAuthorSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.articleRevenue_template.validationsList.clearMessages();
                if (responseParsed.data) {

                    obj.articleRevenue_template.setAuthorsFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.articleRevenue_template.deactivateLoading();
            });
        }
    }
    
    protected onGetMultipleAutoCompleteIdeatorSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.articleRevenue_template.validationsList.clearMessages();
                if (responseParsed.data) {

                    obj.articleRevenue_template.setIdeatorsFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.articleRevenue_template.deactivateLoading();
            });
        }
    }

    protected onGetMultipleAutoCompleteTagsSuggestionsReturn(req, obj){

         return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.articleRevenue_template.validationsList.clearMessages();
                if (responseParsed.data) {

                    obj.articleRevenue_template.setTagsFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.articleRevenue_template.deactivateLoading();
            });
        }
    }

    protected onGetMultipleAutoCompleteTagTypesSuggestionsReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.articleRevenue_template.validationsList.clearMessages();
                if (responseParsed.data) {

                    obj.articleRevenue_template.setTagTypesFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.articleRevenue_template.deactivateLoading();
            });
        }
    }

    protected onGetMultipleAutoCompleteCategoriesSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.articleRevenue_template.validationsList.clearMessages();
                if (responseParsed.data) {

                    obj.articleRevenue_template.setPrimaryCategoriesFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.articleRevenue_template.deactivateLoading();
            });
        }
    }

    protected onGetMultipleAutoCompletePrimaryTagsSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.articleRevenue_template.validationsList.clearMessages();
                if (responseParsed.data) {

                    obj.articleRevenue_template.setPrimaryTagsFilterItems(responseParsed.data);
                    obj.articleRevenue_template.setTopPerformingArticlePrimaryTagsFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.articleRevenue_template.deactivateLoading();
            });
        }
    }

    protected onGetMultipleAutoCompleteTopPerformingCategoriesSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.articleRevenue_template.validationsList.clearMessages();
                if (responseParsed.data) {

                    obj.articleRevenue_template.setTopPerformingArticlePrimaryCategoriesFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.articleRevenue_template.deactivateLoading();
            });
        }
    }

    protected onGetMultipleAutoCompleteTopPerformingTagsSuggestionsReturn(req, obj) {

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.articleRevenue_template.validationsList.clearMessages();
                if (responseParsed.data) {

                    obj.articleRevenue_template.setTopPerformingArticlePrimaryTagsFilterItems(responseParsed.data);
                }

                // LOADING : ends
                obj.articleRevenue_template.deactivateLoading();
            });
        }
    }

    protected onFilterRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);
                obj.articleRevenue_template.validationsList.clearMessages();

                obj.updateFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getListData();

                // LOADING : ends
                obj.loadingOut(obj.articleRevenue_template.builtTemplate);
            });
        }
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.articleRevenue_template.resetSelectedRows();

                // update the paginator
                obj.articleRevenue_template.setPaginationTotalCount(responseParsed.totalCount);

                obj.articleRevenue_template.validationsList.clearMessages();
                obj.updateList(responseParsed.data);

                // LOADING : ends
                obj.loadingOut(obj.articleRevenue_template.builtTemplate.children.namedItem("content-wrapper"));
            });
        };
    }

    protected updateFilters(responseParsed: any){

        this.articleRevenue_template.setBrandFilterItems(responseParsed.brands);
        this.articleRevenue_template.setPostInitiativesFilterItems(responseParsed.postInitiatives);
        this.articleRevenue_template.setPostIntentsFilterItems(responseParsed.postIntents);
        this.articleRevenue_template.setPostContentTypesFilterItems(responseParsed.groupedContentTypes);
        this.articleRevenue_template.setNetworkCategoriesFilterItems(responseParsed.groupedNetworkCategories);
        this.articleRevenue_template.setCountriesFilterItems(responseParsed.countries);
        this.articleRevenue_template.setPublishStatusItems();
    }

    protected updateList(responseParsed: any) {

        this.articleRevenue_template.setTableData(responseParsed);
    }

    protected setResultInfo(totalCount, totalPage){
        let execTime = Math.round((new Date().getTime() - this.XHRHdl.requestStartTime)/1000*100)/100;
        this.articleRevenue_template.setResultInfo(totalCount, totalPage, execTime);
    }

    protected filterMultipleSelectorOnChange(){

        this.resetPageNumber();
        this.getListData();
    }

    protected filterDateOnChange(){

        this.resetPageNumber();
        this.getListData();
    }

    protected filterSingleDateOnChange(){

        this.resetPageNumber();
        this.getListData();
    }

    protected filterSimpleOnChange(){

        this.resetPageNumber();
        this.getListData();
    }

    protected filterSimpleCancel(): void {

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterDropdownOnChange(){

        this.resetPageNumber();
        this.getListData();
    }

    public listReorder(){

        this.getListData();
    }

    protected paginationOnPageClick(){

        this.getListData();
    }

    private resetPageNumber(){

        // go back to page 1 in the pagination
        this.articleRevenue_template.resetPageNumber();
    }

    private dataReorder(id) {

        this.getListData();
    }

    public getExportData(): void{
        let subViewModel;
        let usrReq_url: string = '';
        let usrReq_params: Array<Array<string>> = [];
        let exportData;

        switch(this.articleRevenue_template.getTemplateViewModel().viewModeSelected()) {
            case 'topPerformingArticles':
                subViewModel = this.articleRevenue_template.getViewModelForTopPerformingArticlesRequest();
                usrReq_url = '/api/topPerformingArticle/export/';
                exportData = this.onGetTopPerformingArticleExportData;
            break;

            default:
                subViewModel = this.articleRevenue_template.getViewModelForRequest();
                usrReq_url = '/api/articleRevenue/export/';
                exportData = this.onGetExportData;
            break;
        }

        this.loadingIn(this.articleRevenue_template.builtTemplate.children.namedItem("content-wrapper"));

        this.XHRHdl.cancelAndReset();

        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = exportData;
        this.XHRHdl.execute();
    }

    protected onGetExportData(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                if (req.request.status == 200) {
                    obj.loadingOut(obj.articleRevenue_template.builtTemplate.children.namedItem("content-wrapper"));

                    obj.articleRevenue_template.validationsList.clearMessages();
                    obj.articleRevenue_template.setExportData(responseParsed);
                    obj.articleRevenue_template.exportData();
                }
            });
        }
    }

    protected onGetTopPerformingArticleExportData(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                if (req.request.status == 200) {
                    obj.loadingOut(obj.articleRevenue_template.builtTemplate.children.namedItem("content-wrapper"));

                    obj.articleRevenue_template.validationsList.clearMessages();
                    obj.articleRevenue_template.setTopPerformingArticleExportData(responseParsed.data, responseParsed.totals);
                    obj.articleRevenue_template.exportData();
                }
            });
        }
    }

    protected onTopPerformingArticleFilterRequestReturn(req, obj) {
        return function (){

            obj.manageResponse(req, obj, function (){
                let responseParsed = JSON.parse(req.request.response);
                obj.articleRevenue_template.validationsList.clearMessages();

                obj.updateTopPerformingArticleFilters(responseParsed);
                obj.updateViewModelFromPath();
                obj.getListData();
                // LOADING : ends
                obj.loadingOut(obj.articleRevenue_template.builtTemplate);
            });
        }
    }

    protected updateTopPerformingArticleFilters(responseParsed) {
        this.articleRevenue_template.setTopPerformingArticleBrands(responseParsed.departments);
        this.articleRevenue_template.setTopPerformingArticleBrandSegments(responseParsed.brandSegments);
        this.articleRevenue_template.setTopPerformingArticleDeviceFilterItems(responseParsed.devices);
        this.articleRevenue_template.setTopPerformingArticlePremiumFilterItems(articleRevenue.premiumFilter);
        this.articleRevenue_template.setTopPerformingArticleArticleTypeFilterItems();
        this.articleRevenue_template.setTopPerformingArticlePostContentTypesFilterItems(responseParsed.groupedContentTypes);
        this.articleRevenue_template.setTopPerformingArticlePostContentTypesGroupFilterItems(articleRevenue.contentTypesGroup);
        this.articleRevenue_template.setTopPerformingArticleReportLimitFilterItems(articleRevenue.reportLimit);
        this.articleRevenue_template.getTemplateViewModel().topPerformingArticleReportLimitFilter.setSelectedOption("50");

        this.articleRevenue_template.setPostIntentsFilterItems(responseParsed.postIntents);
        this.articleRevenue_template.setPostInitiativesFilterItems(responseParsed.postInitiatives);
        this.articleRevenue_template.setNetworkCategoriesFilterItems(responseParsed.groupedNetworkCategories);
        this.articleRevenue_template.setCountriesFilterItems(responseParsed.countries);
        this.articleRevenue_template.setPublishStatusItems();
        this.articleRevenue_template.setPostPaymentCategorySystemFilterItems(responseParsed.postPaymentCategorySystems);
        this.articleRevenue_template.setBrandSafetyFilterItems();
    }

    protected onTopPerformingArticlesDataRequestReturn(req, obj){
        return function (){
            obj.manageResponse(req, obj, function (){
                let responseParsed = JSON.parse(req.request.response);
                obj.articleRevenue_template.resetSelectedRows();
                obj.articleRevenue_template.setTopPerformingArticleTableData(responseParsed.data.topArticles.data);
                obj.articleRevenue_template.setTopPerformingArticleTableDataTotals(responseParsed.data.totals);
                obj.articleRevenue_template.setPaginationTotalCount(responseParsed.data.topArticles.totalCount);
                obj.setResultInfo(responseParsed.data.topArticles.totalCount, responseParsed.data.topArticles.totalPage);
                obj.articleRevenue_template.setDisclaimer(responseParsed.data.disclaimer);
                obj.articleRevenue_template.setIsCurrentDay(responseParsed.data.isCurrentDay);
                obj.articleRevenue_template.setDateUpdated(responseParsed.data.dateUpdated);

                // LOADING : ends
                obj.loadingOut(obj.articleRevenue_template.builtTemplate.children.namedItem("content-wrapper"));
            });
        };
    }

}



// WEBPACK FOOTER //
// ./js/modules/articleRevenue.ts